import { AccordionSummary as MuiAccordionSummary, Theme, styled } from '@material-ui/core';

const AccordionSummary = styled(MuiAccordionSummary)<Theme>(({ theme }) => ({
  position: 'relative',
  '&.Mui-expanded': {
    minHeight: '4.8rem',
    borderBottom: theme.config.defaultBorder(theme.palette.grey['100']),
  },
}));
export default AccordionSummary;
